// @owners { team: patients-team }
import { type ShipmentTipInputState } from '~shared/reducers/ui/shipmentTipInput';
import { type ReduxStateShared } from '~shared/types';

export const getTipPaymentMethodIDInput = (state: ReduxStateShared): number | null | undefined =>
  state.ui.shipmentTipInput.tipPaymentMethodID;

export const getShipmentTipInput = (state: ReduxStateShared): ShipmentTipInputState => state.ui.shipmentTipInput;
